module.exports = __webpack_public_path__ + "de_CH-download-ad3874.webp";